<template>
  <OCol stretch-xy left class="ma-6" style="height: 500px">
    <OMap2
      ref="theMap"
      :style="{zIndex: 1}"
      :markers="markers"
      :polygons="polygons"
      :showPOI="false"
      :maxZoom="20"
    />
  </OCol>
</template>

<script>
import { WifiNetwork } from '@/models'
import OMap2 from 'oderon-vue/maps/OMap2'

function makeMarker(hb) {
  return {
    id: hb.hbId,
    icon: 'circle',
    cssClass: 'solid cm-green',
    lat: hb.lat,
    lng: hb.lng
  }
}

function makeSquare({minLat, minLng, maxLat, maxLng}) {
  if ( minLat == null ) return null
  return {
    id: 1,
    points: [
      [minLat, minLng],
      [minLat, maxLng],
      [maxLat, maxLng],
      [maxLat, minLng],
    ]
  }
}

export default {
  components: { OMap2 },
  tabTitle: 'Mapa',
  props: {
    value: { required: true }
  },
  data() {
    return {
      usage: []
    }
  },
  computed: {
    markers() {
      if ( this.usage.rows == null ) return []
      return this.usage.rows.map(hb => makeMarker(hb))
    },
    polygons() {
      const boundingBox = makeSquare(this.usage)
      return boundingBox ? [boundingBox] : []
    }
  },
  watch: {
    value() {
      this.fetchData()
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.usage = await WifiNetwork.getUsage(this.value.id)
      setTimeout(() => this.fitBounds(), 200)
    },

    fitBounds() {
      window._reusableMap = this.$refs.theMap

      const bounds = [
        [this.usage.minLat, this.usage.minLng],
        [this.usage.maxLat, this.usage.maxLng],
      ]
      this.$refs.theMap.fitBounds(bounds, 20)
    }
  }
}
</script>

<style lang="sass">
.vehicle-marker.hb-marker
  background-color: #00ff00 !important
  border: 2px solid #000000 !important
</style>
